<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <ToastContainer />
    <!-- Navigation Header -->
    <nav class="bg-white shadow-lg border-b border-gray-200 sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
          <!-- Logo/Brand -->
          <div class="flex items-center space-x-3">
            <div
              @click="
                if ($store.getters.userId == '6160879304') {
                  $router
                    .push({
                      name: 'admin',
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }
              "
              class="w-9 h-9 rounded-lg overflow-hidden ring-1 ring-gray-200 bg-white"
            >
              <img
                src="@/assets/logo.jpg"
                alt="Company Logo"
                class="w-full h-full object-cover"
              />
            </div>
            <h1 class="text-xl font-bold text-gray-700">ያለ ደላላ ሽያጭ</h1>
          </div>

          <!-- Navigation Links -->
          <div class="hidden md:flex items-center space-x-8">
            <router-link
              @click="mobileMenuOpen = false"
              to="/Dashboard"
              :class="[
                'px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200',
                $route.path === '/'
                  ? 'text-blue-600'
                  : 'text-gray-700 hover:text-blue-600',
              ]"
            >
              የሚሸጥ ይለጥፉ
            </router-link>
            <router-link
              @click="mobileMenuOpen = false"
              :to="{ name: 'myrental' }"
              :class="[
                'px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200',
                $route.name === 'myrental'
                  ? 'text-blue-600'
                  : 'text-gray-700 hover:text-blue-600',
              ]"
            >
              የእኔ ልጥፎች
            </router-link>
            <router-link
              @click="mobileMenuOpen = false"
              :to="{ name: 'rentalList' }"
              :class="[
                'px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200',
                $route.name === 'rentalList'
                  ? 'text-blue-600'
                  : 'text-gray-700 hover:text-blue-600',
              ]"
            >
              የሚሸጡ ንብረቶች
            </router-link>

            <a
              @click="gotoTgSupport"
              href="#"
              class="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
            >
              ያግኙን
            </a>
          </div>

          <!-- User Actions -->
          <div class="flex items-center space-x-4">
            <!-- <button class="text-gray-700 hover:text-blue-600 p-2 rounded-md transition-colors duration-200">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-5 5-5-5h5v-5a7.5 7.5 0 00-15 0v5h5l-5 5-5-5h5V7a7.5 7.5 0 0115 0v10z"></path>
              </svg>
            </button> -->
            <button
              @click="gotoTg"
              class="bg-gradient-to-r from-[#fe5722] to-[#d84315] text-white px-3 py-1.5 rounded-md text-xs font-medium hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-sm hover:shadow-lg"
            >
              ቴሌግራም
            </button>
          </div>

          <!-- Mobile menu button -->
          <div class="md:hidden">
            <button
              @click="mobileMenuOpen = !mobileMenuOpen"
              class="text-gray-700 hover:text-blue-600 p-2 rounded-md"
            >
              <svg
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Mobile drawer (left) -->
        <transition name="fade">
          <div v-if="mobileMenuOpen" class="md:hidden fixed inset-0 z-50">
            <!-- Backdrop -->
            <div
              class="absolute inset-0 bg-black/40"
              @click="mobileMenuOpen = false"
            ></div>

            <!-- Drawer -->
            <transition name="drawer-slide">
              <aside
                class="absolute left-0 top-0 h-full w-72 max-w-[80vw] bg-white shadow-2xl border-r border-gray-200 flex flex-col"
              >
                <!-- Drawer header -->
                <div
                  class="flex items-center justify-between px-4 py-4 border-b border-gray-200"
                >
                  <div class="flex items-center space-x-2">
                    <div
                      class="w-8 h-8 rounded-md overflow-hidden ring-1 ring-gray-200 bg-white"
                    >
                      <img
                        src="@/assets/logo.jpg"
                        alt="Company Logo"
                        class="w-full h-full object-cover"
                      />
                    </div>
                    <span class="text-base font-semibold text-gray-900"
                      >ያለ ደላላ ሽያጭ</span
                    >
                  </div>
                  <button
                    @click="mobileMenuOpen = false"
                    class="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors"
                    aria-label="Close menu"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <!-- Drawer nav -->
                <nav class="flex-1 overflow-y-auto">
                  <ul class="py-3 space-y-0.5">
                    <li>
                      <router-link
                        @click="mobileMenuOpen = false"
                        to="/Dashboard"
                        :class="[
                          'flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors',
                          $route.path === '/Dashboard'
                            ? 'text-blue-600 bg-blue-50'
                            : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50',
                        ]"
                      >
                        <svg
                          class="w-4 h-4 mr-3 text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                          />
                        </svg>
                        የሚሸጥ ይለጥፉ
                      </router-link>
                    </li>
                    <li>
                      <a
                        href="#"
                        @click="
                          mobileMenuOpen = false;
                          $router.push({ name: 'myrental' }).catch((err) => {});
                        "
                        :class="[
                          'flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors',
                          $route.name === 'myrental'
                            ? 'text-blue-600 bg-blue-50'
                            : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50',
                        ]"
                      >
                        <svg
                          class="w-4 h-4 mr-3 text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M3 7h18M3 12h18M3 17h18"
                          />
                        </svg>
                        የእኔ ልጥፎች
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        @click="
                          mobileMenuOpen = false;
                          $router
                            .push({ name: 'rentalList' })
                            .catch((err) => {});
                        "
                        :class="[
                          'flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors',
                          $route.name === 'rentalList'
                            ? 'text-blue-600 bg-blue-50'
                            : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50',
                        ]"
                      >
                        <svg
                          class="w-4 h-4 mr-3 text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M20 13V7a2 2 0 00-2-2h-3V3H9v2H6a2 2 0 00-2 2v6m16 0a2 2 0 01-2 2h-3v3H9v-3H6a2 2 0 01-2-2m16 0H4"
                          />
                        </svg>
                        የሚሸጡ ንብረቶች
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        @click="gotoTgSupport"
                        class="flex items-center px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-md text-sm font-medium transition-colors"
                      >
                        <svg
                          class="w-4 h-4 mr-3 text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9"
                          />
                        </svg>
                        ያግኙን
                      </a>
                    </li>
                  </ul>
                </nav>

                <!-- Drawer footer -->
                <div class="border-t border-gray-200 p-4">
                  <button
                    @click="gotoTg"
                    class="w-full bg-gradient-to-r from-[#fe5722] to-[#d84315] text-white px-4 py-2 rounded-lg text-sm font-medium hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-md hover:shadow-lg"
                  >
                    ቴሌግራም
                  </button>
                </div>
              </aside>
            </transition>
          </div>
        </transition>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="flex-1">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="bg-gray-900 text-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div class="col-span-1 md:col-span-2">
            <div class="flex items-center space-x-3 mb-4">
              <div
                class="w-9 h-9 rounded-lg overflow-hidden ring-1 ring-gray-700 bg-white/5"
              >
                <img
                  src="@/assets/logo.jpg"
                  alt="Company Logo"
                  class="w-full h-full object-cover"
                />
              </div>
              <h3 class="text-xl font-bold">ያለ ደላላ ሽያጭ</h3>
            </div>
            <p class="text-gray-400 mb-4 max-w-md">
              The easiest way to sell and buy items in your community. Connect
              with neighbours and discover amazing things to buy. በማህበረሰብዎ ውስጥ
              እቃዎችን ለመሸጥ እና ለመግዛት ቀላሉ መንገድ።
            </p>
            <div class="flex space-x-5">
              <!-- YouTube -->
              <a
                href="#"
                class="text-red-600 hover:text-red-700 transition-colors duration-200"
                aria-label="YouTube"
              >
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M23.498 6.186a3.004 3.004 0 0 0-2.115-2.127C19.6 3.5 12 3.5 12 3.5s-7.6 0-9.383.559A3.004 3.004 0 0 0 .502 6.186C0 7.977 0 12 0 12s0 4.023.502 5.814a3.004 3.004 0 0 0 2.115 2.127C4.4 20.5 12 20.5 12 20.5s7.6 0 9.383-.559a3.004 3.004 0 0 0 2.115-2.127C24 16.023 24 12 24 12s0-4.023-.502-5.814zM9.75 15.5v-7l6 3.5-6 3.5z"
                  />
                </svg>
              </a>
              <!-- TikTok -->
              <a
                href="#"
                class="text-pink-600 hover:text-pink-700 transition-colors duration-200"
                aria-label="TikTok"
              >
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M16.5 3a6.5 6.5 0 0 0 5 2.4V8a9.5 9.5 0 0 1-5-1.4V14a6 6 0 1 1-6-6c.35 0 .69.03 1.02.1V11a3 3 0 1 0 3 3V3h2.98z"
                  />
                </svg>
              </a>
              <!-- Telegram -->
              <a
                @click="gotoTg"
                class="text-sky-500 hover:text-sky-600 transition-colors duration-200"
                aria-label="Telegram"
              >
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M9.036 15.803l-.36 5.084c.514 0 .736-.221 1.002-.485l2.406-2.31 4.99 3.653c.914.504 1.562.239 1.812-.846l3.286-15.38.001-.001c.291-1.357-.49-1.885-1.38-1.555L1.53 9.73c-1.31.509-1.291 1.243-.223 1.577l4.794 1.497 11.16-7.04c.525-.318 1.002-.144.609.174"
                  />
                </svg>
              </a>
            </div>
          </div>
          <!-- <div>
            <h4 class="text-lg font-semibold mb-4">Product</h4>
            <ul class="space-y-2">
              <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Features</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Pricing</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >API</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Documentation</a
                >
              </li>
            </ul>
          </div> -->
          <!-- <div>
            <h4 class="text-lg font-semibold mb-4">Company</h4>
            <ul class="space-y-2">
              <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >About</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Blog</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Careers</a
                >
              </li>
              <li>
                <a
                 
                  @click="gotoTg"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Contact</a
                >
              </li>
            </ul>
          </div> -->
          <div>
            <h4 class="text-lg font-semibold mb-4">Support</h4>
            <ul class="space-y-2">
              <li>
                <a
                  href="#"
                  @click="gotoTgSupport"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Help Center</a
                >
              </li>
              <!-- <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Community</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Privacy</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="text-gray-400 hover:text-white transition-colors duration-200"
                  >Terms</a
                >
              </li> -->
            </ul>
          </div>
        </div>
        <div
          class="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400"
        >
          <p>&copy; 2025 ያለ ደላላ ሽያጭ. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref } from "vue";
import ToastContainer from "@/components/ToastContainer.vue";

const mobileMenuOpen = ref(false);
function gotoTg() {
  window.location.href = "https://t.me/yaledelala_sales";
}

function gotoTgSupport() {
  window.location.href = "https://t.me/yaledelala_support";
}
</script>

<style>
#app {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Drawer slide animation */
.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 250ms ease, opacity 250ms ease;
  will-change: transform, opacity;
}
.drawer-slide-enter-from,
.drawer-slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>
